import React from "react";
import "./FilterContainer.scss";

interface FiltersContainerProps {
  left?: React.ReactNode;
  right?: React.ReactNode;
  children?: React.ReactNode;
}

const FilterContainer = (props: FiltersContainerProps) => {
  return (
    <div className="filter-container">
      {props.left ? <div className="filter-container__left">{props.left}</div> : null}
      {/* <div className="filter-container__separator" /> */}
      {props.right ? <div className="filter-container__right">{props.right}</div> : null}
      {props.children ? <div className="filter-container__right">{props.children}</div> : null}
    </div>
  );
};

export default FilterContainer;
